import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { Error404Component } from './error-404.component';


@NgModule({
  declarations: [
    Error404Component
  ],
  imports: [
    MatIconModule,
    RouterModule,
    FuseSharedModule,
    TranslateModule,
    MatButtonModule
  ]
})
export class Error404Module {
}
